<!-- <tdd-modal
  *ngIf="data"
  [title]="'Application Error'"
  [contentTemp]="content"
  [size]="'md'"
  [scrollable]="true"
  [optClose]="true"
  (closed)="close()"
>
</tdd-modal>

<ng-template #content>
  <div class="error-modal">

    <p class="title">
      The operation could not be completed
    </p>

    <p class="message">
      {{ data?.message }}
    </p>

    <div class="meta">
      <div><strong>Status:</strong> {{ data?.statusCode }}</div>

      <div *ngIf="data?.method">
        <strong>Method:</strong> {{ data?.method }}
      </div>

      <div *ngIf="data?.url">
        <strong>URL:</strong> {{ data?.url }}
      </div>
    </div>

    <div class="correlation" *ngIf="data?.correlationId">
      <label>Correlation ID</label>

      <div class="box">
        <code>{{ data?.correlationId }}</code>

        <button (click)="copy()">
          {{ copied ? 'Copied' : 'Copy ID' }}
        </button>
      </div>

      <p class="help">
        Provide this Correlation ID to the develpment team.
      </p>
    </div>

    <div class="actions">
      <button (click)="close()">Close</button>
    </div>

  </div>
</ng-template>
 -->
<motif-modal-title variant="alt">
  <h3>Tax Suite error</h3>

  <button
    class="button-error-modal"
    motifIconButton
    aria-label="Close modal"
    type="button"
    (click)="close()"
  >
    <app-dynamic-icon [icon]="'close'"></app-dynamic-icon>
  </button>
</motif-modal-title>

<motif-modal-content>
  <div class="error-modal">
    <p class="title">An error occurred while processing your request</p>

    <p class="message">
      {{ data?.message }}
    </p>

    <!-- TODO: Cazar el mensaje de error de cada caso de uso. -->

    <div class="correlation" *ngIf="data?.correlationId">
      <label>Correlation ID</label>

      <div class="box">
        <code>{{ data?.correlationId }}</code>

        <button motifButton color="primary-alt" type="button" (click)="copy()">
          {{ copied ? 'Copied' : 'Copy ID' }}
        </button>
      </div>

      <p class="help">
        Please provide this identifier to the development team.
      </p>
    </div>
  </div>
</motif-modal-content>

<motif-modal-actions class="actions-footer">
  <button motifButton color="primary-alt" type="button" (click)="close()">
    Close
  </button>
</motif-modal-actions>
